import { Suspense, type ReactNode } from "react"
import { BrowserRouter as Router } from "react-router-dom"

// import { ToastContainer } from 'react-toastify'

import { ApiClientProvider } from "@/providers/ApiClientProvider"
import { AuthProvider } from "@/providers/AuthProvider"
import { NavigationProvider } from "@/providers/NavigationProvider"
import { OnboardingProvider } from "@/providers/OnboardingProvider"
import { ThemeProvider } from "@/providers/ThemeProvider"

import AlertProvider from "@/components/alert/alert"
import LoadingScreen from "@/components/loading-screen/loading-screen"

/**
 * Combines all application providers in the correct order
 */
export const AppProviders = ({ children }: { children?: ReactNode }) => {
  return <Router basename="">
      <AlertProvider>
        <AuthProvider>
          <NavigationProvider>
            <ApiClientProvider>
              <ThemeProvider>
                <Suspense fallback={<LoadingScreen />}>
                  <OnboardingProvider>
                    {children}
                  </OnboardingProvider>
                </Suspense>
              </ThemeProvider>
            </ApiClientProvider>
          </NavigationProvider>
        </AuthProvider>
      </AlertProvider>
    </Router>
}

export default AppProviders 